"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
var TranscriptItemType;
(function (TranscriptItemType) {
    TranscriptItemType["PRONUNCIATION"] = "pronunciation";
    TranscriptItemType["PUNCTUATION"] = "punctuation";
})(TranscriptItemType || (TranscriptItemType = {}));
exports.default = TranscriptItemType;
//# sourceMappingURL=TranscriptItemType.js.map